module.exports = __webpack_public_path__ + "img/inputTip3_1.1b067d29.png";